"use strict";
import { useAccount } from "hooks/useAccount";
import { useEthersProvider } from "hooks/useEthersProvider";
import { useEthersSigner } from "hooks/useEthersSigner";
import { useShowSwapNetworkNotification } from "hooks/useShowSwapNetworkNotification";
import { useMemo } from "react";
import { UniswapProvider } from "uniswap/src/contexts/UniswapContext";
import { AccountType } from "uniswap/src/features/accounts/types";
function useWebProvider(chainId) {
  return useEthersProvider({ chainId });
}
function useWagmiAccount() {
  const account = useAccount();
  return useMemo(() => {
    if (!account.address) {
      return void 0;
    }
    return {
      address: account.address,
      type: AccountType.SignerMnemonic
    };
  }, [account.address]);
}
export function WebUniswapProvider({ children }) {
  const account = useWagmiAccount();
  const signer = useEthersSigner();
  const showSwapNetworkNotification = useShowSwapNetworkNotification();
  return <UniswapProvider
    account={account}
    signer={signer}
    useProviderHook={useWebProvider}
    onShowSwapNetworkNotification={showSwapNetworkNotification}
  >{children}</UniswapProvider>;
}
